<template>
    <div class="grid items-center grid-cols-12 text-xs bg-white dark:bg-neutral-950">
        <div class="col-span-4 py-2 pl-2">
            <div v-if="event.title && event.title.name" class="truncate">
                <inertia-link :href="event.admin_url" class="font-semibold underline hover:no-underline">
                    {{ event.title.name }}
                </inertia-link>
            </div>
            <div v-if="event.venue && event.venue.name">
                {{ event.venue.name }}
            </div>
        </div>
        <div v-if="event.datetime_from" class="col-span-1 truncate">
            {{ dateTimeHumanReadableWithoutYearFromISO(event.datetime_from) }}
        </div>
        <div class="col-span-1">
            {{ event.seats_total }}
        </div>
        <div class="col-span-1">
            {{ event.seats_available }}
        </div>
        <div class="col-span-1">
            {{ event.seats_sold }}
        </div>
        <div class="col-span-1">
            {{ event.seats_reserved }}
        </div>
        <div class="col-span-1">
            {{ event.seats_blocked }}
        </div>
        <div class="col-span-1">
            {{ event.seats_ordered }}
        </div>
        <div class="flex justify-end col-span-1 pr-4">
            <Button :a="true" :href="event.url" target="_blank">
                <icon icon="hero/outline/eye" class="size-4"></icon>
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { Event } from '@src/Events/Pages/types';
import { dateTimeHumanReadableWithoutYearFromISO } from '@src/Common/Helpers/dates';

interface Props {
    event?: Event | null;
}

const props = withDefaults(defineProps<Props>(), {
    event: null,
});

const event = toRef(props, 'event');
</script>
